import { render, staticRenderFns } from "./LinkedinCompanyView.vue?vue&type=template&id=a908a4fa"
import script from "./LinkedinCompanyView.vue?vue&type=script&lang=js"
export * from "./LinkedinCompanyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports